// import React from 'react';
namespace React { export type FC<T> = {}; export type ChangeEvent<T> = { target } };

import { DropDownBook } from '../models';

const linkLocation = 'abbreviation'; // or 'name' (originally)

interface BookProps
{
    bookId: number;
    books: { [id: number]: DropDownBook };
    enableFavorites: boolean;
    onBookSelect: (book: DropDownBook, checked: boolean) => void;
}

const ReactBook: React.FC<BookProps> = ({
    bookId,
    books,
    enableFavorites,
    onBookSelect,
}) =>
{
    const book: DropDownBook = books[bookId];

    const sourceAbbreviation =
        book.sourcePartAbbreviation ?? book.sourceAbbreviation ??
        book.linkingAbbreviation;

    const linkingAbbreviation = book.linkingAbbreviation;

    let link = null;
    // TODO: remove accents on the backend or simply provide both abbreviations by hand…
    //       ?? sourceAbbreviation.replace(…)
    let className = linkingAbbreviation;
    className = ['source-link', 'bold', className].filter(a => a).join(' ');

    const handleBookSelect = (e: React.ChangeEvent<HTMLInputElement>) =>
    {
        onBookSelect(bookId, e.target.checked);
    };

    const handleFavoriteIconClick = (e) =>
    {
        console.info('TODO: favorite icon clicked:', book.name);
    }

    // NOTE: BibliographyLine does this too
    if (linkingAbbreviation) {
        link = "Text/" + encodeURIComponent(linkingAbbreviation);
    }

    // TODO: also an author name (at most one?)
    const dictionaryName = (
        <span className="concrete-item-name">{book.name}</span>
    );

    const abbreviation = (
        sourceAbbreviation && <>
            {' '}
            [{ // NOTE: the brackets (parentheses, originally) are literal
                // @ts-ignore
                linkLocation == 'name' || !link ?

                <span
                    className={className}
                >{sourceAbbreviation}</span> :

                // linkLocation == 'abbreviation'
                <a
                    href={link}
                    target="_blank"
                    className={className}
                >{sourceAbbreviation}</a>
            }]
        </>
    );

    const favoriteIcon = enableFavorites ?
        getFavoriteIcon({
            hasLabels: false,
            handleFavoriteIconClick,
        }) :
        null;

    return (
        <div key={bookId} className="concrete-item">
            <label className="book-checkbox-and-name">
                <input
                    type="checkbox"
                    className="concrete-item-checkbox checkbox"
                    checked={book.selected}
                    onChange={handleBookSelect}
                />

                {
                    // @ts-ignore
                    link && linkLocation == 'name' ?

                    <a
                        href={link}
                        target="_blank"
                    >{dictionaryName}</a> :

                    dictionaryName
                }
            </label>

            {abbreviation}

            {favoriteIcon}
        </div>
    );
};

const getFavoriteIcon = ({
    hasLabels,
    handleFavoriteIconClick,
}) =>
{
    const iconClassName = `glyphicon-star${hasLabels ? "" : "-empty"}`;

    return (
        <span className="save-item">
            <a className="favorite-star">
                <span
                    className={`glyphicon ${iconClassName}`}
                    onClick={handleFavoriteIconClick}
                />
            </a>
        </span>
    );
}

//  XXX: default exports are not supported by the loadUMD2GlobalHack
export { ReactBook, getFavoriteIcon };
